import { useQuery } from '@tanstack/react-query';
import { deploymentsApi, Deployment } from '../api/deploymentsApi';

export const deploymentsQueryKey = (serviceDeskId?: number) =>
  serviceDeskId ? ['deployments', serviceDeskId] : ['deployments'];

export const useDeployments = (serviceDeskId?: number) => {
  const {
    data: deployments = [],
    isLoading,
    error,
    refetch,
  } = useQuery<Deployment[]>({
    queryKey: deploymentsQueryKey(serviceDeskId),
    queryFn: () => deploymentsApi.list(serviceDeskId),
  });

  return {
    deployments,
    isLoading,
    error: error as Error | null,
    refetch,
  };
};
